import React from 'react';
import { Mail, Phone, MapPin, Star, StickyNote, AlertTriangle } from 'lucide-react';
import type { CustomerContact } from '../../types';
import { Button } from '@/components/ui/button';

interface ContactItemProps {
  contact: CustomerContact;
  onUpdate: (contact: CustomerContact) => Promise<void>;
  onDelete: (contact: CustomerContact) => Promise<void>;
}

export const ContactItem: React.FC<ContactItemProps> = ({
  contact,
  onUpdate,
  onDelete,
}) => {
  const icons = {
    email: Mail,
    phone: Phone,
    address: MapPin,
  };
  const Icon = icons[contact.type];

  return (
    <div className={`flex items-center justify-between p-4 rounded-lg ${
      contact.isPrimary ? 'bg-primary/5 border-2 border-primary/10' : 'bg-muted'
    }`}>
      <div className="flex items-center space-x-3">
        <Icon className={`w-5 h-5 ${contact.isPrimary ? 'text-primary' : 'text-muted-foreground'}`} />
        <div>
          <p className={`${contact.isPrimary ? 'font-medium' : ''}`}>
            {contact.value}
          </p>
          {contact.label && (
            <p className="text-sm text-muted-foreground">{contact.label}</p>
          )}
        </div>
      </div>
      <div className="flex items-center space-x-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => {
            const label = window.prompt('Enter a label for this contact', contact.label || '');
            if (label !== null) {
              onUpdate({
                ...contact,
                raw: { ...contact.raw, label }
              });
            }
          }}
        >
          <StickyNote className="w-4 h-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onUpdate({
            ...contact,
            isPrimary: !contact.isPrimary,
            raw: { ...contact.raw, is_primary: !contact.isPrimary }
          })}
        >
          <Star className={`w-4 h-4 ${contact.isPrimary ? 'fill-primary' : ''}`} />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onDelete(contact)}
          className="text-destructive"
        >
          <AlertTriangle className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};